module.exports = __webpack_public_path__ + "img/int-company.09711870.svg";